import { render, staticRenderFns } from "./QSP.vue?vue&type=template&id=20664756&"
import script from "./QSP.vue?vue&type=script&lang=js&"
export * from "./QSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports